import { useState, useEffect } from "react";

const useAdBlockDetector = (): boolean => {
 const [isAdBlockEnabled, setIsAdBlockEnabled] = useState<boolean>(false);

 useEffect(() => {
  const detectAdBlock = async (): Promise<void> => {
   try {
    // Create a bait element
    const bait = document.createElement("div");
    bait.setAttribute(
     "class",
     "ads ad adsbox doubleclick ad-placement carbon-ads"
    );
    bait.setAttribute(
     "style",
     "height: 1px; width: 1px; position: absolute; left: -999px; top: -999px;"
    );
    document.body.appendChild(bait);

    // Wait a brief moment for potential adblocker to act
    await new Promise((resolve) => setTimeout(resolve, 100));

    // Check if the bait element was hidden or removed
    const isBlocked =
     !bait.offsetParent ||
     !bait.offsetHeight ||
     !bait.offsetLeft ||
     !bait.offsetTop ||
     !bait.offsetWidth ||
     window.getComputedStyle(bait).display === "none";

    setIsAdBlockEnabled(isBlocked);

    // Clean up
    document.body.removeChild(bait);
   } catch (error) {
    setIsAdBlockEnabled(true); // Assume blocker exists if there's an error
   }
  };

  detectAdBlock();
 }, []);

 return isAdBlockEnabled;
};

export default useAdBlockDetector;
